import { SvgIcon } from '@material-ui/core'
import { motion } from 'framer-motion'

export default function MixerIcon({ active, ...props }: any) {
    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
            <line x1="8" y1="4" x2="8" y2="20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <line x1="16" y1="4" x2="16" y2="20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />

            <motion.circle
                cx="8"
                cy={9}
                r="2.5"
                fill="currentColor"
                initial={false}
                animate={{ cy: active ? 15 : 9 }}
                transition={{ duration: 0.3, ease: 'easeInOut' }}
            />
            <motion.circle
                cx="16"
                cy={15}
                r="2.5"
                fill="currentColor"
                initial={false}
                animate={{ cy: active ? 9 : 15 }}
                transition={{ duration: 0.3, ease: 'easeInOut' }}
            />
        </SvgIcon>
    )
}
